import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Paper,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";

import { useInView } from "react-intersection-observer";
import { useDebounce } from "use-debounce";
import { useTheme } from "@emotion/react";
import { AuthContext } from "../../../context/AuthContext";
import InfiniteScrollerTable from "../../../components/InfiniteScroller/InfiniteScrollerTable";
import ListFooter from "../../../components/InfiniteScroller/ListFooter";
import useWeeklyTimeSummariesByCurrentUser from "../../../hooks/useWeeklyTimeSummariesByCurrentUser";

import { toThreeDecimals } from "../../../components/NewDetail/calculations/utils";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const TimeApprovals = ({ search, status }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [
    weeklyUserTimeApprovals,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  ] = useWeeklyTimeSummariesByCurrentUser(authToken, 25, search, status);

  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5, //Number between 0 and 1 indicating the percentage that should be visible before triggering. Can also be an array of numbers, to create multiple trigger points.
  });

  const [inViewDebounce] = useDebounce(inView, 1000);

  // Update URL
  const updateSearch = (searchUpdate, statusUpdate) => {
    let query = [];
    if (searchUpdate || statusUpdate) {
      if (searchUpdate) {
        query.push(`search=${searchUpdate}`);
      }
      if (statusUpdate) {
        query.push(`status=${statusUpdate}`);
      }
    }
    if (query.length > 0) {
      navigate(`/weekly-time-summaries?${query.join("&")}`); // search=hello&status=DRAFT
    } else {
      navigate(`/weekly-time-summaries`);
    }
  };

  useEffect(() => {
    if (weeklyUserTimeApprovals.length > 0 && inView) {
      console.log("Footer Element In View. Load More...");
      onLoadMore();
    }
  }, [inViewDebounce]);

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <Box
        sx={
          {
            // width: "100%",
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "flex-end",
            // alignItems: "center",
            // marginTop: "16px",
            // marginBottom: "16px",
          }
        }
      >
        {/* <Box sx={{ marginLeft: "8px", flex: 1 }}>
          <TextFieldDebounced
            fullWidth
            variant="outlined"
            label="Search"
            value={search}
            onChange={(e) => {
              updateSearch(e.target.value, status);
            }}
          />
        </Box> */}
        {/* <TextField
          sx={{ width: "200px", marginLeft: "8px" }}
          select
          label="Status"
          value={status}
          onChange={(e) => {
            updateSearch(search, e.target.value);
          }}
        >
          <MenuItem value={"PENDING_PAYMENT"}>Pending Payment</MenuItem>
          <MenuItem value={"PAID"}>Paid</MenuItem>
          <MenuItem value={"CANCELLED"}>Cancelled</MenuItem>
          <MenuItem value={"ALL"}>All</MenuItem>
        </TextField> */}
      </Box>
      <InfiniteScrollerTable
        TableContainerComponent={Paper}
        TableStyle={{ minWidth: "600px" }}
        TableHead={() => (
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ width: "200px" }}>
                Status
              </TableCell>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Start</TableCell>
              <TableCell align="left">End</TableCell>
              {!isSmallScreen && (
                <TableCell align="left">Week Total Hours</TableCell>
              )}
              {!isSmallScreen && (
                <TableCell align="left">No-Work Days</TableCell>
              )}
            </TableRow>
          </TableHead>
        )}
        items={weeklyUserTimeApprovals}
        renderRow={(item, index) => {
          return (
            <TableRow
              key={item.id}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  background: "#eeeeee",
                },
              }}
              onClick={() => {
                navigate(`/weekly-time-summaries/${item.id}`);
              }}
            >
              <TableCell align="left">
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ borderRadius: "25px" }}
                  color={item.employeeSignedOn ? "success" : "warning"}
                >
                  {item.employeeSignedOn ? "SIGNED" : "UNSIGNED"}
                </Button>
              </TableCell>
              <TableCell align="left">{item.id}</TableCell>
              <TableCell align="left">
                {dayjs(item.start).tz(DEFAULT_TIMEZONE).format("MM/DD/YY")}
              </TableCell>
              <TableCell align="left">
                {dayjs(item.stop)
                  .tz(DEFAULT_TIMEZONE)
                  // For some reason, endOf week is saved as 12:00 am the next day isntead of 11:59:59
                  // So endOf week is actually startOf next week
                  .subtract(1, "millisecond")
                  .format("MM/DD/YY")}
              </TableCell>
              {!isSmallScreen && (
                <TableCell align="left">
                  {toThreeDecimals(Number(item.totalWorkMinutes ?? 0) / 60)}
                </TableCell>
              )}
              {!isSmallScreen && (
                <TableCell align="left">
                  {Number(item.totalNoWorkDays ?? 0)}
                </TableCell>
              )}
            </TableRow>
          );
        }}
        onRefresh={onRefresh}
        onEndReached={onLoadMore}
        loading={refreshing || loadingMore}
        ListFooterComponent={() => {
          return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
        }}
      />
    </Box>
  );
};
export default TimeApprovals;
